import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { SmartAutoComplete } from "@nodeon/react-components";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDropdownOptions } from "../hooks/useDropdownOptions";
import { SearchFormData } from "../tabs/SecurityDeviceSearchTab";
import { SharedFormProps } from "../WaterTrafficSignContainers/WaterTrafficSignStateForm";

export type FeaturesFormTypes = {
  navigationType: string | null; // ilmansuunnat?
  light: null | boolean;
  structure: string | null;
};

export const featuresFormDefaultValues: FeaturesFormTypes = {
  navigationType: null,
  light: null,
  structure: null,
};

export const FeaturesForm = ({ isDisabled }: SharedFormProps) => {
  const { t } = useTranslation("fairwayReport");
  const { control } = useFormContext<SearchFormData>();
  const { searchResult, isLoading } = useDropdownOptions();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      {/* <Typography>{t("fairwayReport:deviceIdOrName")}</Typography> */}

      <SmartAutoComplete<SearchFormData, string, false>
        disabled={isDisabled}
        name="navigationType"
        label={t("navigationType")}
        options={searchResult?.navigationTypes ?? []}
        loading={isLoading}
        controllerProps={{ control }}
      />
      <FormControl disabled={isDisabled}>
        <FormLabel>{t("fairwayReport:alight")}</FormLabel>
        <Controller
          name="light"
          control={control}
          render={({ field }) => (
            <RadioGroup
              sx={{ display: "flex", flexDirection: "row" }}
              {...field}
              onChange={(_e, v) =>
                field.onChange(v === "null" ? null : v === "true")
              }
            >
              <FormControlLabel
                value="null"
                control={<Radio />}
                label={t("faultSearch:kaikki")}
              />
              <FormControlLabel
                value
                control={<Radio />}
                label={t("actionSearch:light")}
              />
              <FormControlLabel
                value={false}
                control={<Radio />}
                label={t("actionSearch:notLight")}
              />
            </RadioGroup>
          )}
        />
      </FormControl>
      <SmartAutoComplete<SearchFormData, string, false>
        disabled={isDisabled}
        name="structure"
        label={t("fairwayReport:structure")}
        loading={isLoading}
        options={searchResult?.structures ?? []}
        controllerProps={{ control }}
        // renderInput={(params) => <TextField {...params} />}
      />
    </Box>
  );
};
